export const RESERVED = "RESERVED";
export const COMPLETED = "COMPLETED";
export const PENDING = "PENDING";
export const CREATED = "CREATED";
export const CANCELED = "CANCELED";
export const OPEN = "OPEN";
export const CLOSED = "CLOSED";

export const labelState = {
  [PENDING]: "Pendiente",
  [RESERVED]: "Reservado",
  [COMPLETED]: "Completado",
  [CREATED]: "Creado",
  [CANCELED]: "Cancelado",
  [OPEN]: "Abierto",
  [CLOSED]: "Cerrado",
};

export const colorState = {
  [PENDING]: "primary",
  [RESERVED]: "light",
  [COMPLETED]: "primary",
  [CREATED]: "success",
  [CANCELED]: "primary",
  [OPEN]: "info",
  [CLOSED]: "warning",
};

export const Status = {
  RESERVED,
  COMPLETED,
  PENDING,
  CREATED,
  CANCELED,
  OPEN,
};
